module.exports = __webpack_public_path__ + "static/media/Experty.261b8891.jpeg";